import { Component } from '@angular/core';
import { ISummaryData } from '../../../../core/models/summary-data';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SummaryService } from '../../../../core/services/summary.service';
import { FunnelService } from '../funnel/funnel.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader.service';
import { TranslateService } from '@ngx-translate/core';

type Fee = {
  FeeType: number;
  Amount: number;
};

type FeeDisplay = {
  descripcion: string;
  total: number;
};

@Component({
  selector: 'app-successful-payment',
  standalone: false,
  templateUrl: './successful-payment.component.html',
  styleUrl: './successful-payment.component.scss',
})
export class SuccessfulPaymentComponent {
  orderHash: string = '';
  summaryData: ISummaryData = {} as ISummaryData;
  showDropin = false;
  pickDay: string = '';
  pickHour: string = '';
  totalOrder: number = 0;
  totalOrderWithFee: number = 0;
  fixedFee: number = 0;
  form!: FormGroup;
  extraProducts: any[] = [];
  haveExtraProducts: boolean = false;
  extrasTotalPrice: number = 0;
  vehicleType: number = 0;
  fuelType: number = 0;
  groupFees: FeeDisplay[] = [];
  brandingId = localStorage.getItem('brandingId') ?? '';
  pickStart: string = '';
  pickEnd: string = '';
  isRefueling: boolean = false;
  isExtraRefueling: boolean = false;
  fuelLabelExtra: string = '';
  fuelLabel: string = '';

  constructor(
    private summaryService: SummaryService,
    private funnelService: FunnelService,
    private router: Router,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private translate: TranslateService
  ) {
    this.summaryData = this.summaryService.getSummary() ?? ({} as ISummaryData);
  }

  ngOnInit() {
    const productTitle = this.summaryData.productInformation?.product?.title;
    const fuelType = this.summaryData.serviceConfiguration?.fuelType;

    if (productTitle === 'Repostaje') {
      this.isRefueling = true;
      this.fuelLabel = this.getFuelLabel(fuelType ?? 0);
    }

    const fees: Fee[] = this.summaryData.bookingResponse?.Fees || [];
    this.groupFees = this.agruparFeesPorTipo(fees);

    this.form = this.fb.group({
      requirements: [false],
      terms: [false],
    });
    this.orderHash = this.summaryData.bookingResponse?.OrderHash ?? '';
    const { diaRecogida, horaRecogida } = this.formatDates(
      this.summaryData.locationInfo?.ServiceStartDate ?? '',
      this.summaryData.locationInfo?.ServiceEndDate ?? ''
    );
    console.log('summaryData', this.summaryData);
    this.fixedFee = this.summaryData.locationInfo?.FixedFee ?? 0;
    this.totalOrder =
      this.summaryData.bookingResponse?.Products?.[0]?.Amount ?? 0;
    this.extraProducts =
      this.summaryData.bookingResponse?.Products?.slice(1) ?? [];
    if (this.extraProducts.length > 0) {
      for (const extra of this.extraProducts) {
        this.extrasTotalPrice += extra.Amount;
        if (extra.ProductKey === 'refueling-topping') {
          this.isExtraRefueling = true;
          this.fuelLabelExtra = this.getFuelLabel(extra.FuelType);
        }
      }
      this.haveExtraProducts = true;
    }
    this.totalOrderWithFee = Number(
      this.totalOrder +
        this.fixedFee +
        this.extrasTotalPrice +
        (this.summaryData.bookingResponse?.TotalOrderTaxAmount ?? 0)
    );
    this.pickDay = diaRecogida;
    this.pickHour = horaRecogida;

    this.vehicleType = this.summaryData.vehicleData?.vehicleType ?? 0;
    this.fuelType = this.summaryData.vehicleData?.fuelType ?? 0;
  }

  finalOrder() {
    this.loaderService.show();
    this.funnelService
      .finalBook(this.orderHash)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe({
        next: (resp) => {
          const ps = resp.body.FinancialData.PaymentSession;
          const adyenSession = {
            id: ps.PaymentId,
            sessionData: ps.PaymentData,
          };
          localStorage.setItem(
            'adyenSessionPaymentData',
            JSON.stringify(adyenSession)
          );
          this.router.navigate(['/payment'], {
            queryParams: { brandingId: this.brandingId },
          });
        },
        error: (err) => console.error(err),
      });
  }

  getFuelTypeText(fuelType: number): string {
    if (fuelType === 1) return 'petrol';
    if (fuelType === 3) return 'diesel';
    return 'Unknown';
  }

  startPayment() {
    this.loaderService.show();
    this.funnelService
      .createPaymentSession(this.orderHash)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe({
        next: (resp) => {
          const ps = resp.FinancialData.PaymentSession;
          const session = { id: ps.PaymentId, sessionData: ps.PaymentData };
          localStorage.setItem('adyenSession', JSON.stringify(session));
          this.router.navigate(['/payment'], {
            queryParams: { brandingId: this.brandingId },
          });
        },
        error: (err) => console.error('Error creando sesión', err),
      });
  }

  formatDates(
    serviceStartDate: string,
    serviceEndDate: string
  ): { diaRecogida: string; horaRecogida: string } {
    const extractDate = (raw: string): Date | null => {
      const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
      if (!match) return null;

      const [_, year, month, day, hour, minute] = match.map(Number);
      return new Date(year, month - 1, day, hour, minute);
    };

    const start = extractDate(serviceStartDate);
    const end = extractDate(serviceEndDate);

    if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) {
      console.warn('Fechas no válidas:', { serviceStartDate, serviceEndDate });
      return {
        diaRecogida: 'Fecha inválida',
        horaRecogida: 'Hora inválida',
      };
    }

    const diaRecogida = `${start.getDate().toString().padStart(2, '0')} / ${(
      start.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')} / ${start.getFullYear()}`;

    const startTime = `${start.getHours().toString().padStart(2, '0')}:${start
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;
    const endTime = `${end.getHours().toString().padStart(2, '0')}:${end
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;

    this.pickStart = `${start.getHours().toString().padStart(2, '0')}:${start
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;
    this.pickEnd = `${end.getHours().toString().padStart(2, '0')}:${end
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;

    const horaRecogida = this.translate.instant('pickup-between', {
      start: startTime,
      end: endTime,
    });

    return { diaRecogida, horaRecogida };
  }

  getFuelLabel(type: number): string {
    const map: Record<number, string> = {
      1: 'Gasolina',
      3: 'Diésel',
      5: 'Híbrido',
      6: 'Eléctrico',
    };
    return map[type] || 'Desconocido';
  }

  getVehicleTypeLabel(type: number): string {
    const map: Record<number, string> = {
      1: 'Turismo',
      2: 'Monovolumen',
      3: 'Todoterreno',
      4: 'SUV',
      5: 'Coupé',
    };
    return map[type] || 'Desconocido';
  }

  returnToStart() {
    localStorage.clear();
    this.router.navigate(['/landing'], {
      queryParams: { brandingId: this.brandingId },
    });
  }

  private obtenerDescripcionFee(feeType: number): string {
    switch (feeType) {
      case 1:
        return this.translate.instant('cafler-fee');
      case 2:
        return this.translate.instant('fixed-fee');
      case 3:
        return this.translate.instant('urgent-fee');
      case 100:
        return this.translate.instant('refuel-fee');
      default:
        return this.translate.instant('cafler-fee');
    }
  }

  private agruparFeesPorTipo(fees: Fee[]): FeeDisplay[] {
    const agrupados: Record<number, number> = {};

    for (const fee of fees) {
      agrupados[fee.FeeType] = (agrupados[fee.FeeType] || 0) + fee.Amount;
    }

    return Object.entries(agrupados)
      .filter(([_, total]) => total > 0)
      .map(([feeTypeStr, total]) => ({
        descripcion: this.obtenerDescripcionFee(+feeTypeStr),
        total: parseFloat(total.toFixed(2)),
      }));
  }
}
